import { render, staticRenderFns } from "./ItemListLavorazione.vue?vue&type=template&id=7dd15fc9"
import script from "./ItemListLavorazione.vue?vue&type=script&lang=ts"
export * from "./ItemListLavorazione.vue?vue&type=script&lang=ts"
import style0 from "./ItemListLavorazione.vue?vue&type=style&index=0&id=7dd15fc9&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dd15fc9')) {
      api.createRecord('7dd15fc9', component.options)
    } else {
      api.reload('7dd15fc9', component.options)
    }
    module.hot.accept("./ItemListLavorazione.vue?vue&type=template&id=7dd15fc9", function () {
      api.rerender('7dd15fc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemListLavorazione.vue"
export default component.exports